export class InputTypes {
  static readonly TEXT = 'text';
  static readonly DATE = 'date';
  static readonly NUMBER = 'number';
  static readonly EMAIL = 'email';
  static readonly ALL = [
    InputTypes.TEXT,
    InputTypes.DATE,
    InputTypes.NUMBER,
    InputTypes.EMAIL,
  ];
}
